/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './admission-aux-patient.reducer';

export const AdmissionAuxPatientDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const admissionAuxPatientEntity = useAppSelector(state => state.admissionAuxPatient.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="admissionAuxPatientDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.detail.title">AdmissionAuxPatient</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.id">Id</Translate>
            </span>
          </dt>
          <dd>{admissionAuxPatientEntity.id}</dd>
          <dt>
            <span id="primary">
              <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.primary">Primary</Translate>
            </span>
          </dt>
          <dd>{admissionAuxPatientEntity.primary ? 'true' : 'false'}</dd>
          <dt>
            <span id="billable">
              <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.billable">Billable</Translate>
            </span>
          </dt>
          <dd>{admissionAuxPatientEntity.billable ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.active">Active</Translate>
            </span>
          </dt>
          <dd>{admissionAuxPatientEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{admissionAuxPatientEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{admissionAuxPatientEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{admissionAuxPatientEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{admissionAuxPatientEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{admissionAuxPatientEntity.glucoUser ? admissionAuxPatientEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionAuxPatient.admission">Admission</Translate>
          </dt>
          <dd>{admissionAuxPatientEntity.admission ? admissionAuxPatientEntity.admission.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/admission-aux-patient" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/admission-aux-patient/${admissionAuxPatientEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AdmissionAuxPatientDetail;
